import '../../Icon.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs } from "react/jsx-runtime";
import "../../Styling.js";
import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";
import "../../Utilities.js";
import { Icon } from "@fluentui/react/lib/Icon";
import { WithCallout } from "../Callout/WithCallout.js";
import { SuccessIconType } from "./Icon.types.js";
/* empty css                   */import { mergeStyles } from "@fluentui/style-utilities";
import { css } from "@fluentui/utilities";
const defaultClassNameContainer = "ane-SuccessIcon-container";
const defaultClassName = "ane-SuccessIcon";
const defaultClassTextContainer = "ane-SuccessIcon-textContainer";
const defaultIconStyles = {
  root: {
    paddingTop: "0px",
    paddingRight: "4px",
    paddingBottom: "0px",
    paddingLeft: "4px",
    width: "32px",
    height: "32px",
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "32px",
    boxSizing: "border-box"
  }
};
const innerIconClass = mergeStyles({
  fontSize: 20,
  root: {
    paddingRight: "15px"
  }
});
const iconClass = mergeStyles({
  root: {
    paddingRight: "15px"
  }
});
const iconClassNames = mergeStyleSets({
  red: [{ color: getTheme().palette.redDark }, iconClass],
  orange: [{ color: getTheme().palette.orange }, iconClass],
  green: [{ color: getTheme().palette.green }, iconClass],
  solidRed: [{ color: getTheme().palette.redDark }, innerIconClass],
  solidOrange: [{ color: getTheme().palette.orange }, innerIconClass],
  solidGreen: [{ color: getTheme().palette.green }, innerIconClass]
});
const getIconWithText = (props, Icon2) => {
  const { onClick } = props;
  return !!onClick ? Icon2 : /* @__PURE__ */ jsx("div", { className: defaultClassNameContainer, children: /* @__PURE__ */ jsxs("div", { className: "flexContainer", children: [
    Icon2,
    /* @__PURE__ */ jsxs("div", { className: defaultClassTextContainer, children: [
      props.text,
      " ",
      props.children
    ] })
  ] }) });
};
const SuccessIcon = (props) => {
  let _a = props, { className, styles, children } = _a, rest = __objRest(_a, ["className", "styles", "children"]);
  const defaultStyles = __spreadValues(__spreadValues({}, defaultIconStyles), styles);
  var Icon$1;
  switch (props.successIconType) {
    case SuccessIconType.success: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "Completed", className: iconClassNames.green }));
      break;
    }
    case SuccessIconType.successSolid: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "CompletedSolid", className: iconClassNames.solidGreen }));
      break;
    }
    case SuccessIconType.warning: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "Warning", className: iconClassNames.orange }));
      break;
    }
    case SuccessIconType.warningSolid: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "WarningSolid", className: iconClassNames.solidOrange }));
      break;
    }
    case SuccessIconType.error: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "ErrorBadge", className: iconClassNames.red }));
      break;
    }
    case SuccessIconType.errorSolid: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "StatusErrorFull", className: iconClassNames.solidRed }));
      break;
    }
    case SuccessIconType.blocking: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "Blocked2", className: iconClassNames.red }));
      break;
    }
    case SuccessIconType.blockingSolid: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "Blocked2Solid", className: iconClassNames.solidRed }));
      break;
    }
    case SuccessIconType.alertSolid: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "AlertSolid", className: iconClassNames.solidRed }));
      break;
    }
    case SuccessIconType.alert: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, iconName: "Error", className: iconClassNames.red }));
      break;
    }
    default: {
      Icon$1 = /* @__PURE__ */ jsx(Icon, __spreadProps(__spreadValues({}, rest), { styles: defaultStyles, className: css(defaultClassName, className) }));
    }
  }
  const IconWrapper = /* @__PURE__ */ jsx(WithCallout, { calloutProps: props.calloutProps, children: Icon$1 });
  return getIconWithText(props, IconWrapper);
};
export {
  SuccessIcon,
  SuccessIcon as default
};
//# sourceMappingURL=SuccessIcon.js.map
